module.exports = __webpack_public_path__ + "media/images/color_admin_v3/login-bg/bg-7-442b1b2da3d2eb36966c22300c6ebd37.jpg";